import { createSelector } from 'reselect';
import BalanceOnHandThresholdsColumns from '../../containers/BalanceOnHandThresholdsColumns';
import TableDefinitions from '../../../../../../common/TableDefinitions';

export const getIsLoading = (state) => state.listing.BALANCE_ON_HAND_THRESHOLDS_PAGE.isLoading;
export const getCheckedRows = (state) => state.listing.BALANCE_ON_HAND_THRESHOLDS_PAGE.selectedRows;
export const getData = TableDefinitions.BALANCE_ON_HAND_THRESHOLDS_PAGE.getDataFunction();
export const getColumns = createSelector(
  getData,
  (state) => state.userData.userInfo[0].split('_'),
  BalanceOnHandThresholdsColumns,
);
